import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD8NoeDQL45RBD7StR-VVmQcfu8men5egM",
  authDomain: "choseiapp.firebaseapp.com",
  projectId: "choseiapp",
  storageBucket: "choseiapp.firebasestorage.app",
  messagingSenderId: "847194789829",
  appId: "1:847194789829:web:5ef863559d132ae10addac"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db   = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
